import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//消费商品打卡返还
export default [{
  path: "/clock/activityIndex",
  name: "clockIndex",
  component: function component() {
    return import("../../../views/activityClock/clockIndex/clockIndex");
  },
  meta: {
    title: "活动聚合页",
    foot: true
  }
}, {
  path: "/clock/clockMember",
  name: "clockMember",
  component: function component() {
    return import("../../../views/activityClock/clockMember/clockMember");
  },
  meta: {
    title: "消费商品打卡返还",
    foot: true
  }
}, {
  path: "/clock/clockDetails",
  name: "clockDetails",
  component: function component() {
    return import("../../../views/activityClock/clockDetails/clockDetails");
  },
  meta: {
    title: "活动详情",
    foot: true
  }
}, {
  path: "/clock/clockAdd",
  name: "clockAdd",
  component: function component() {
    return import("../../../views/activityClock/clockAdd/clockAdd");
  },
  meta: {
    title: "打卡",
    foot: true
  }
}, {
  path: "/clock/clockCalendar",
  name: "clockCalendar",
  component: function component() {
    return import("../../../views/activityClock/clockCalendar/clockCalendar");
  },
  meta: {
    title: "打卡日历",
    foot: true
  }
}];